import watch from 'redux-watch';

/* @ngInject */
export function AdministrationAccountsHeadOfficeRscController($ngRedux, $uiRouterGlobals, $mdDialog, AdministrationActions) {
    var ctrl = this;
    var dialog = null;
    var unsubscribe = angular.noop;
    var onRsc = angular.noop;

    ctrl.$onInit = function() {
        unsubscribe = $ngRedux.connect(mapStateToThis, AdministrationActions)(ctrl);

        var watchRsc = watch($ngRedux.getState, 'administration.administrationAccountsHeadOfficeRsc.data.uuid');
        onRsc = $ngRedux.subscribe(watchRsc(function(uuid) {
            onRscReady(uuid);
        }));
    };

    ctrl.newRSC = function() {
        if (ctrl.rsc.uuid) {
            $ngRedux.dispatch({
                type: 'RSC_RESET',
                id: 'administrationAccountsHeadOfficeRsc'
            });
        }
        $ngRedux.dispatch({
            type: 'TAB_SHOW',
            id: 'app.administration.accounts',
            state: ['app.administration.accounts.headOfficesRscDetails'],
            stateParams: $uiRouterGlobals.params
        });
    };

    ctrl.selectRSC = function(event) {
        if (event.item.subject_uuid === ctrl.rsc.uuid)
            onRscReady(event.item.subject_uuid);
        else
            ctrl.getRscDetails('administrationAccountsHeadOfficeRsc', event.item.subject_uuid);
    };

    ctrl.removeRSC = function(event) {
        var confirm = $mdDialog.confirm()
            .title('Are you sure?')
            .textContent('Radiation Safety Coordinator will be deactivated.')
            .ariaLabel('Deactivate RSC')
            .ok('Yes')
            .cancel('No');

        dialog = $mdDialog.show(confirm).then(function() {
            ctrl.removeRsc(event.item.subject_uuid, ctrl.headOffice.uuid, 'administrationAccountsHeadOfficeRsc', 'administrationAccountsHeadOfficeRscGrid');
        }, angular.noop);
    };

    ctrl.$onDestroy = function() {
        if (dialog) $mdDialog.hide(dialog);
        unsubscribe();
        onRsc();
    };

    function onRscReady(uuid) {
        $ngRedux.dispatch({
            type: 'TAB_SHOW',
            id: 'app.administration.accounts',
            state: ['app.administration.accounts.headOfficesRscDetails'],
            stateParams: {
                hof: $uiRouterGlobals.params.hof,
                rsc: uuid
            }
        });
        $ngRedux.dispatch({
            type: 'TAB_LOADING',
            id: 'app.administration.accounts',
            state: 'app.administration.accounts.headOfficesRscDetails',
            loading: false
        });
    }

    function mapStateToThis(state) {
        return {
            headOffice: state.administration.administrationAccountsHeadOffice,
            rsc: state.administration.administrationAccountsHeadOfficeRsc.data,
            title: state.administration.administrationAccountsHeadOffice.name + ' » RSCs'
        };
    }
}
